module.exports = __webpack_public_path__ + "static/media/09n.a1fd3da1.svg";